<template>
  <log-quick-submit
    v-model="activityText"
    :placeholder="placeholder"
    :loading="isLoading"
    data-cy="activity-text-edit"
    class="quick-submit-form"
  >
    <template #actionBar>
      <div />
    </template>
    <template #buttons>
      <modal-buttons
        class="max-h-8 px-0"
        :disabled="!activityText.trim() || isLoading"
        :on-cancel="() => emit('cancel')"
        :on-save="() => emit('submit', activityText)"
      />
    </template>
  </log-quick-submit>
</template>
<script setup lang="ts">
import { ref } from "vue";

import LogQuickSubmit from "@/components/communicationLogs/forms/LogQuickSubmit.vue";
import ModalButtons from "@/components/ui/ModalButtons.vue";

const {
  text,
  isLoading = false,
  placeholder = "",
} = defineProps<{
  text: string;
  isLoading: boolean;
  placeholder?: string;
}>();
const emit = defineEmits<{ submit: [string]; cancel: [] }>();

const activityText = ref(text);
</script>
